@use 'styles/config.module' as *;

.item {
  padding: 0.9rem 0;
  margin: 0 0.3rem 0.2rem;
  border-radius: 0.6rem;
  min-height: 5.8rem;
  position: relative;
  color: rgba(#fff, 0.5);
  &.itemSelected {
    background-color: rgba(#fff, 0.1);
    color: #fff;
    cursor: default;
    .itemSmall {
      font-size: 2.6rem;
    }
  }
  &:hover {
    background-color: rgba(#fff, 0.15);
  }
  &.itemOpen {
    &.itemSelected {
      background-color: rgba($color-primary, 0.08);
      color: $color-primary;
      cursor: default;
    }
  }
}
.itemOpen {
  margin: 0;
  border-radius: 0;
  min-height: 4.8rem;
  padding: 0 1rem 0 3rem;
  position: relative;
  border-right-width: 2px;
  border-right-style: solid;
  color: $color-primary;
}

.itemLong {
  display: grid;
  grid-template-columns: 2.4rem 1fr auto;
  align-items: center;
  width: 100%;
  grid-gap: 1.6rem;
}

.itemSmall {
  width: 7.8rem;
  font-size: 2.4rem;
  &Box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    height: 2.6rem;
    line-height: 0;
    margin: 0 auto;
    position: relative;
  }
  &Arrow {
    position: absolute;
    top: 50%;
    left: 100%;
    margin-left: 0.4rem;
    font-size: 1.8rem !important;
    transform: translateY(-50%);
    &Rtl {
      transform: translateY(-50%) scaleX(-1);
    }
  }
}

.arrow {
  transform: scaleY(1);
  transition: 0.3s;
  font-size: 2rem;
  &Open {
    transform: scaleY(-1);
  }
}

.itemInner {
  min-height: 3.8rem;
  grid-template-columns: 2.4rem 1fr;
}
